module.exports = __webpack_public_path__ + "v4assets/capacity-screenshot-dark.e0bbd2cf25db664ce2cc2433e051f68c.png";